import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TeacherLeaveForm from "@/components/common/teacher_leave/TeacherLeaveForm.vue";
import Select2Multiple from "v-select2-multiple-component";
import Loading from "vue-loading-overlay";
import axios from "axios";

export default {
  name: "leaveCreate",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
    TeacherLeaveForm,
  },

  data() {
    return {
      leaveData: {
        teacher_id: null,
        period: null,
        from_date: null,
        to_date: null,
        request_date: null,
        remark: null,
        status: null,
        login_id: this.$store.state.user.id,
        leave_images: []
      },
      submitted: false,
      disabled: false,
      isLoading: false,
      teacherArr: [],
      images: [],
      formValidations: null,
    };
  },

  methods: {
    setValidations(validations) {
      this.formValidations = validations;
    },

    getTeacher() {
      this.teacher_id = 0;
      axios.get("teacher/getallTeacher", {
          params: {
              campus_id: this.$store.state.user.campus_id
          }
        }).then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Teacher'
          }];
          this.teacherArr = $defaultSelectOption.concat(res.data[0]);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    create() {
      if (this.disabled) return;
      this.isLoading = true;
      this.submitted = true;
      this.disabled = true;

      this.formValidations.$touch(); 
      if (this.formValidations.$invalid || this.leaveData.teacher_id == null || this.leaveData.teacher_id == 0) {
        this.isLoading = false;
        this.disabled = false;
        return;
      }
      this.leaveData.leave_images = this.images;
      axios.post('teacher/leave/create', this.leaveData)
        .then(res => {
          if(res.data.success == true) {
            this.$notification.success("Leave Form Create Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'teacherLeaveList'
            })
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            if (error.response.status == 422) {
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
        });
    },
  },

  watch: {
    'leaveData.teacher_id'(newVal) {
      if (!newVal) return;

      const exists = this.teacherArr.some(opt => opt.id == newVal);
      if (!exists) {
        this.leaveData.teacher_id = null;
        this.teacherArr = [...this.teacherArr];
      }
    }
  },

  mounted() {
    this.isLoading = true;
    this.getTeacher();
  }
};
